import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Button, Container, Grid2, FormControlLabel, Switch, } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { getAllAuditList, closeAudit } from '../../../features/AdminManagement/auditSlice'
import axios from 'axios'
import '../../../services/GlobalVariables'

export default function AuditListing() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { listData, isLoading } = useSelector((state) => state.audit)
    const [auditStatus, setAuditStatus] = React.useState(true)

    React.useEffect(() => {
        dispatch(getAllAuditList({ getOrder: true }))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'auditID', cName: 'Audit ID', textAlign: 'left', width: 70, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Audit Date', textAlign: 'left', width: 100, status: 'en', dType: 'date' },
        { fieldName: 'branchName', cName: 'Branch', textAlign: 'left', width: 120, status: 'en', dType: 'string' },
        { fieldName: 'createdBy', cName: 'Created By', textAlign: 'left', width: 120, status: 'en', dType: 'string' },
        { fieldName: 'approvalStatus', cName: 'Status', textAlign: 'center', width: 100, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 200, status: 'en', dType: 'string' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 60, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Close', textAlign: 'center', width: 60, status: 'en', dType: 'string', buttonText: "Close" },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/InvAudit', { state: { auditID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }
    const onButtonClick = async (auditID) => {
        dispatch(closeAudit({ auditID: auditID })).then(() => dispatch(getAllAuditList))
    }
    const onDeleteAllAudits = async () => {
        if (!window.confirm('Delete ALL audits? Audit records and history will be permanently deleted. Posted stock will not be changed.')) return
        if (!window.confirm('Final confirmation: this action cannot be undone. Continue?')) return
        try {
            const response = await axios.post(global.SET_API_URL + 'audit/deleteAllAudits')
            window.alert(response.data.message)
            dispatch(getAllAuditList({ getOrder: auditStatus }))
        } catch (error) {
            window.alert(error.response?.data?.message || error.message || 'Unable to delete audits')
        }
    }
    const onAddNewClick = () => {

        navigate('/InvAudit')

    }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={9}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={auditStatus}
                                    onChange={(e) => {
                                        setAuditStatus(e.target.checked)
                                        dispatch(getAllAuditList({ getOrder: e.target.checked }))

                                    }
                                    }
                                    name="branchStatus"
                                />
                            }
                            label={auditStatus ? "Opened Audit List" : "Closed Audit List"}
                        />
                    </Grid2>
                    <Grid2 size={3} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                        <Button color="error" variant="outlined" onClick={onDeleteAllAudits}>Delete All Audits</Button>
                        <ButtonNormal text='Open New Audit' onClick={onAddNewClick} />
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={listData && listData.data && listData.data.length > 0 ? listData.data : []}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} onButtonClick={onButtonClick} />
                }

            </Container>
        </>
    )
}